import { render, staticRenderFns } from "./AddEditForm.vue?vue&type=template&id=5221d740&scoped=true"
import script from "./AddEditForm.vue?vue&type=script&lang=js"
export * from "./AddEditForm.vue?vue&type=script&lang=js"
import style0 from "./AddEditForm.vue?vue&type=style&index=0&id=5221d740&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5221d740",
  null
  
)

export default component.exports